import axiosClient from ".";
class WithdrawalHistoryAPI {
  static get_withdrawal_histories_data(currentPage) {
    return axiosClient.get(
      `/api/v1/transaction/withdrawals?page=${currentPage}`
    );
  }
}
export default WithdrawalHistoryAPI;
